module.exports = __webpack_public_path__ + "static/img/6.21f6606.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/eng/6.png
// module id = S4Oz
// module chunks = 0